__turbopack_context__.v({
  "default": "textarea-module-scss-module__RSlFmq__default",
  "destructive": "textarea-module-scss-module__RSlFmq__destructive",
  "disabled": "textarea-module-scss-module__RSlFmq__disabled",
  "root": "textarea-module-scss-module__RSlFmq__root",
  "success": "textarea-module-scss-module__RSlFmq__success",
  "textarea": "textarea-module-scss-module__RSlFmq__textarea",
  "warning": "textarea-module-scss-module__RSlFmq__warning",
});
